<div class="component-container">
    <div class="what-makes-us-container">
        <h1 class="font-mont-semi-bold">What makes us different?</h1>
        <div class="dif-Box clearfix">
            <div>
                <img src="/assets/images/icons/document.svg" alt="document" />
            </div>
            <div>
                <span class="font-mont-semi-bold title">No Documents Required</span>
                <span class="font-mont-book">No trip to the bank. Complete everything online.</span>
            </div>
        </div>
        <div class="dif-Box clearfix">
            <div>
                <img src="/assets/images/icons/clock.svg" alt="clock" />
            </div>
            <div>
                <span class="font-mont-semi-bold title">Amazingly Fast Process</span>
                <span class="font-mont-book">Complete your entire purchase in less than 10 minutes.</span>
            </div>
        </div>
        <div class="dif-Box clearfix">
            <div>
                <img src="/assets/images/icons/check.svg" alt="check" />
            </div>
            <div>
                <span class="font-mont-semi-bold title">Pick Your Payment</span>
                <span class="font-mont-book">Choose the terms that work best for your budget.</span>
            </div>
        </div>
        <div class="dif-Box">
            <div class="speed">
                <img src="/assets/images/icons/speed.svg" alt="speed" />
            </div>
            <div>
                <span class="font-mont-semi-bold title">All Credit Scores Welcome</span>
                <span class="font-mont-book">
                    Whether you have great credit, bad credit, or no credit at all, we have a solution.
                </span>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>
    <div class="need-help-container">
        <a class="helpLink"
            href="https://home-c35.nice-incontact.com/incontact/chatclient/chatclient.aspx?poc=97e77c7f-d8a6-4af0-95eb-f8975110c562&bu=4599274"
            target="_blank">
            <h1 class="font-mont-semi-bold">Need Help? Have Questions? </h1>
        </a>
        <div class="font-mont-regular">
            Call <span class="font-mont-regular">1-888-509-5592</span>
        </div>
    </div>
</div>